var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Wrapper',{on:{"click":_vm.execute}},[_c('img',{attrs:{"alt":`${_vm.icon}`,"src":require(`@/assets/${_vm.icon}.svg`),"height":"18px","width":"18px"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }